
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Activite from '@/extend/classes/Activite';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeActivite' })

export default class storeActivite extends VuexModule {
  // States
  private reccords: Activite[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get activiteLoading (): boolean {
    return this.dataLoading;
  }
  private get activiteRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get activiteLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewActivite() {
    return (): Activite => { 
      return this.getActivite(0, true);
    }
  }

  
  public get getActivite () {
    return (id: number, canCreate = false): Activite => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Activite can't be 0")
        return new Activite();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Activite();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Activite.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromActivite(data.reccords[0] as Activite);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listActivite (): Activite[] {
    return this.reccords;
  }

  public get listConfigActivite (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mActiviteRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mActiviteClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mActiviteLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mActiviteLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Activite.fromJson(reccord as Activite));
    })
    Activite.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mActiviteConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mActiviteCreated (obj: Activite): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareActivite(obj)) {
          api.fromActivite(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareActivite(obj)) {
            api.fromActivite(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mActiviteUpdated (obj: Activite): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareActivite(obj)) {
          api.fromActivite(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mActiviteDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerActivite (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.activiteRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerActivite(this.activiteCreated, this.activiteUpdated, this.activiteDeleted);
          this.mActiviteRegistered();
        } else {
          setTimeout(() => resolve(this.registerActivite(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.activiteLoading && !this.activiteLoaded) {
          this.mActiviteLoading(true);
          return Activite.list(filter)
            .then((data: ListData) => {
              this.mActiviteLoaded(data);
              this.mActiviteLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredActivite (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.activiteLoading) {
        this.mActiviteLoading(true);
        return Activite.list(filter)
          .then((data: ListData) => {
            this.mActiviteLoaded(data);
            this.mActiviteLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createActivite (obj: Activite): Promise<Activite> {
    return new Promise((resolve, reject) => {
      return Activite.fromJson(obj).createForStoreActivite()
        .then((reccords) => {
          this.mActiviteCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateActivite (obj: Activite): Promise<Activite> {
    return new Promise((resolve, reject) => {
      return Activite.fromJson(obj).updateForStoreActivite()
        .then((reccords) => {
          this.mActiviteUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteActivite (obj: Activite): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Activite.fromJson(obj).deleteForStoreActivite()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mActiviteDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private activiteCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mActiviteConfigUpdated(config)
    const obj = objConfig.obj as Activite;
    this.mActiviteCreated(Activite.fromJson(obj));
  }

  @Action
  private activiteUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mActiviteConfigUpdated(config)
    const obj = objConfig.obj as Activite;
    this.mActiviteUpdated(Activite.fromJson(obj));
  }

  @Action
  private activiteDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Activite;
    this.mActiviteDeleted(obj.id);
  }
}
